import { render, staticRenderFns } from "./SupplierRequirements.view.vue?vue&type=template&id=04d3e722&"
import script from "./SupplierRequirements.view.vue?vue&type=script&lang=js&"
export * from "./SupplierRequirements.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d3e722')) {
      api.createRecord('04d3e722', component.options)
    } else {
      api.reload('04d3e722', component.options)
    }
    module.hot.accept("./SupplierRequirements.view.vue?vue&type=template&id=04d3e722&", function () {
      api.rerender('04d3e722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/supplier-requirements/SupplierRequirements.view.vue"
export default component.exports